import { TEST_URL, NOT_LOCAL_URL } from './constans'
import { getCookie } from 'typescript-cookie'
export function setUrlSource(source: 'test' | 'notlocal') {
	switch (source) {
		case 'test':
			return TEST_URL
		case 'notlocal':
			return NOT_LOCAL_URL
	}
}
export let mode: 'test' | 'notlocal' = 'notlocal'

export function timeDelay(ms: number) {
	return new Promise(res => setTimeout(res, ms))
}

export const defaultFilterOption = (inputValue: any, option: any) => {
	if (!option.label) return false

	return option.label.toString().toLowerCase().includes(inputValue.toLowerCase())
}
export const dateFormat = 'DD.MM.YYYY'

export const aliasText =
	getCookie('i18next') === 'ky'
		? 'Уникальный идентификатор.  \n' +
		  '- Должен начинаться с буквы\n' +
		  '- Используйте только латинские буквы (a-z, A-Z), цифры (0-9) и символы подчеркивания (_)\n' +
		  '- Не допускаются пробелы и специальные символы (например, !, @, #, $, %, ^, &, *, и т.д.).'
		: 'Уникальный идентификатор.  \n' +
		  '- Должен начинаться с буквы\n' +
		  '- Используйте только латинские буквы (a-z, A-Z), цифры (0-9) и символы подчеркивания (_)\n' +
		  '- Не допускаются пробелы и специальные символы (например, !, @, #, $, %, ^, &, *, и т.д.).'
